
    import { Component, Prop, Vue } from 'vue-property-decorator';

    @Component
    export default class EingetragenAmVom extends Vue {
        @Prop({ default: () => null }) public am!: string | null;
        @Prop({ default: () => null }) public von!: string | null;
        @Prop({ default: () => null }) public mod_am!: string | null;
        @Prop({ default: () => null }) public mod_von!: string | null;
        @Prop({ default: () => 'Eingetragen' }) public eingetragenText!: string;
        @Prop({ default: () => 'Geändert' }) public geaendertText!: string;
    }
